import { useQuery } from "@apollo/client";
import { RouteComponentProps } from "react-router";
import { Spinner } from "../../../components/Spinner";
import "../css/style.css";
import { ArticleViewQuery, ArticleViewResponse } from "../helper/graphql";
import { ArticleView } from "./ArticleView";

type ArticleViewControllerProps = {} & RouteComponentProps<{ id: string }>;

export const ArticleViewController = (props: ArticleViewControllerProps) => {
  const match = props.match;
  let id = "";
  if (match && match.params.id && match.params.id.length > 0)
    id = match.params.id;

  const { loading, error, data, refetch } = useQuery<ArticleViewResponse>(
    ArticleViewQuery,
    {
      variables: { id },
      fetchPolicy: "no-cache",
    }
  );

  if (loading) return <Spinner />;
  if (data && data.article !== null)
    return <ArticleView article_view={data} refetch={refetch} />;

  console.log("got error", error);

  return <p>Error!</p>;
};
